import React from 'react';
import { useAnalyticsInit } from '../hooks/useAnalyticsInit';

export const Analytics: React.FC = () => {
  useAnalyticsInit();
  return <></>;
};
